import { useState, useEffect } from 'react'
import AppShell from '../../Components/AppShell'
import PageHeader from '../../Components/PageHeader'
import DepartmentCards from '../../Components/DepartmentCards'
import LoadingState from '../../Components/LoadingState'
import EmptyState from '../../Components/EmptyState'
import useDepartmentStore from '../../utils/store/departments'

const Home = () => {
  const [loading, setLoading] = useState(true)
  const { departments, fetchDepartments } = useDepartmentStore()
  const [departmentTools, setDepartmentTools] = useState([])

  useEffect(() => {
    setLoading(true)
    fetchDepartments().finally(() => setLoading(false))
  }, [fetchDepartments])

  useEffect(() => {
    if (departments && departments.length > 0) {
      const departmentToolsArray = departments.map((department) => department.tools)
      setDepartmentTools(departmentToolsArray)
    } else {
      setDepartmentTools([])
    }
  }, [departments])

  return (
    <AppShell>
      <PageHeader
        kicker="Workspace"
        title="Department board"
        subtitle="Select a department workspace you have permission to enter."
        crumbs={[{ label: 'Home' }]}
        status={<span className="nx-chip-info">{departments?.length || 0} departments</span>}
      />

      {loading ? (
        <LoadingState label="Loading departments" />
      ) : departments.length === 0 ? (
        <EmptyState
          title="No departments available"
          description="Ask an admin to assign department access or create departments."
        />
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {departments.map(({ department, _id }, index) => (
            <DepartmentCards
              key={_id || index}
              deptId={_id}
              department={department}
              deptTools={departmentTools}
              index={index}
            />
          ))}
        </div>
      )}
    </AppShell>
  )
}

export default Home
